import React, { Component } from "react";
import { propertyUtil } from "views/Pma/PropertyUtil";
import moment from "moment";
import MarketSaleRow from "./MarketSaleRow";
import { isPdfPrintVersion } from "views/Pma/PmaEditor/CommonEditor/pdfPrintVersion";

class YETwoShortenedMarketTable extends Component {
  componentDidMount() {
    if (this.props.pdfPrintVersion || isPdfPrintVersion()) {
      require("./pdfprint.scss");
    } else if (this.props.printVersion) {
      require("./print.scss");
    } else {
      require("./editor.scss");
    }
  }

  getTitle = (area) => {
    const { changeDetails, subdivisionName, coverPageHeader } =
      this.props.hoData;
    const { demoAccountAreaName } = this.props;
    const { splitAreas } = propertyUtil;
    let areaSplit = splitAreas(area);
    let characterCount = areaSplit.join("").length + areaSplit.length;
    let specialFontSize;
    if (characterCount > 40) {
      specialFontSize = "xs-market-sales-title";
    } else if (characterCount > 33) {
      specialFontSize = "small-market-sales-title";
    } else if (characterCount > 27) {
      specialFontSize = "medium-market-sales-title";
    } else {
      specialFontSize = "regular-market-sales-title";
    }
    if (coverPageHeader === "Upper East and Lower Mission Canyon") {
      return (
        <div className="market-sales-title-text small-market-sales-title">
          Lower Mission Canyon and Upper East
        </div>
      );
    } else if (area === "Winchester Canyon") {
      return (
        <div className="market-sales-title-text">
          Rancho Embarcadero & Winchester
        </div>
      );
    } else if (demoAccountAreaName && demoAccountAreaName.length > 1) {
      return (
        <div className="market-sales-title-text">{demoAccountAreaName}</div>
      );
    } else if (
      (changeDetails && changeDetails.subdivisionName) ||
      (subdivisionName && subdivisionName.length > 1)
    ) {
      return (
        <div className="market-sales-title-text">
          {subdivisionName ? subdivisionName : changeDetails.subdivisionName}
        </div>
      );
    } else {
      return (
        <div className={`market-sales-non-sub-container ${specialFontSize}`}>
          {areaSplit.map((area, i) => {
            return (
              <div key={area} className="market-sales-inside-title-row">
                {i > 0 && (
                  <div
                    className={`market-sales-title-separator ${specialFontSize}`}
                  ></div>
                )}

                <p className={`market-sales-title-text ${specialFontSize}`}>
                  {area}
                </p>
              </div>
            );
          })}
        </div>
      );
    }
  };
  getOldestDate = (propList) => {
    let sliced = propList
      .slice(0, 18)
      .sort((a, b) => new Date(a.saleDate) - new Date(b.saleDate))[0].saleDate;
    let formatted = moment(sliced).format("MMM D, YYYY");
    return formatted;
  };
  getTodayDate = () => {
    return moment(new Date()).format("MMM D, YYYY");
  };
  formatLastPrintDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };
  isAgentProperty = (prop) => {
    const { agentFilteredPhotoDetailsList } = this.props.quarterlyAreaTable;
    let someAgentsProperty = agentFilteredPhotoDetailsList.some(
      (property) => property.isAgentFiltered === true,
    );
    if (someAgentsProperty) {
      return true;
    } else {
      return false;
    }
  };
  tableBrokerageFilter = (brokerage) => {
    if (brokerage.includes("Sotheby's")) {
      return "Sotheby's International Realty";
    } else {
      return brokerage;
    }
  };

  highlightedSalesText = (propertyList) => {
    const { listgenUserID } = this.props.agentData;
    let hasAgentSolds = propertyList.filter(
      (property) => property.status === "Sold" && property.isAgentFiltered,
    ).length;
    let hasAgentPending = propertyList.filter(
      (property) =>
        (property.status === "Pending" || property.status === "Contingent") &&
        property.isAgentFiltered,
    ).length;
    let hasAgentActive = propertyList.filter(
      (property) => property.status === "Active" && property.isAgentFiltered,
    ).length;
    let agentRepresentationArray = [];
    if (hasAgentSolds) {
      if (
        (listgenUserID === "100652" || listgenUserID === "108206") &&
        hasAgentSolds === 1
      ) {
        agentRepresentationArray.push("Sold Property");
      } else if (hasAgentSolds === 1) {
        agentRepresentationArray.push("Sold Listing");
      } else if (
        (listgenUserID === "100652" || listgenUserID === "108206") &&
        hasAgentSolds > 1
      ) {
        agentRepresentationArray.push("Sold Properties");
      } else {
        agentRepresentationArray.push("Sold Listings");
      }
    }
    if (hasAgentPending) {
      if (hasAgentPending === 1) {
        agentRepresentationArray.push("Pending Sale");
      } else {
        agentRepresentationArray.push("Pending Sales");
      }
    }
    if (hasAgentActive) {
      if (agentRepresentationArray.length === 0) {
        if (hasAgentActive === 1) {
          agentRepresentationArray.push("Active Listing");
        } else {
          agentRepresentationArray.push("Active Listings");
        }
      } else {
        if (hasAgentActive === 1) {
          agentRepresentationArray.push("Active");
        } else {
          agentRepresentationArray.push("Actives");
        }
      }
    }
    if (agentRepresentationArray.length === 1) {
      return agentRepresentationArray[0];
    } else if (agentRepresentationArray.length === 2) {
      return `${agentRepresentationArray[0]} and ${agentRepresentationArray[1]}`;
    } else if (agentRepresentationArray.length === 3) {
      return `${agentRepresentationArray[0]}, ${agentRepresentationArray[1]}, and ${agentRepresentationArray[2]}`;
    }
    return "Sales";
  };
  render() {
    const {
      currentArea,
      quarterlyAreaTable,
      printVersion,
      sorted,
      useExtendedTable,
      agentData,
      tableMonthStyles,
    } = this.props;
    console.log("table test");
    const { mlsAreaID } = currentArea;
    let { listgenUserID, isMemberOfTeam, teamMembers, brokerageName } =
      agentData;
    if (listgenUserID === "102843") {
      isMemberOfTeam = true;
    }
    let { totalActiveListings, totalPendingListings } = quarterlyAreaTable;

    // Check if all properties are active (no sold, pending, or contingent properties)
    let hasAllActiveProperties = sorted.every(
      (prop) => prop.status === "Active",
    );

    let isBuellton = mlsAreaID === "SBA-40F" || mlsAreaID === "SBA-40G";
    const { isAgentProperty, tableBrokerageFilter } = this;
    let oldestSaleDate = sorted
      .filter((prop) => prop.saleDate !== "-")
      .map((x) => x.saleDate)
      .sort((a, b) => new Date(a) - new Date(b))[0];
    const contingentsNum =
      quarterlyAreaTable.marketActivityTable &&
      quarterlyAreaTable.marketActivityTable.filter(
        (list) => list.status === "Contingent",
      ).length;
    let hidePropertyTypeColumn =
      listgenUserID === "109954" || listgenUserID === "100462";
    const currentSolds = (
      <MarketSaleRow
        solds={sorted}
        mlsAreaID={mlsAreaID}
        isSingleTable={true}
        agentData={agentData}
        agentProperties={quarterlyAreaTable.agentFilteredPhotoDetailsList}
        isAgentProperty={isAgentProperty}
        hidePropertyTypeColumn={hidePropertyTypeColumn}
        hasAllActiveProperties={hasAllActiveProperties}
      />
    );
    const tableHeader = (
      <thead>
        <tr>
          <th>Status</th>
          <th className="list-sale-date-th">
            <p>{hasAllActiveProperties ? "List " : "Sale "}</p>
            <p>Date</p>
          </th>
          {!hidePropertyTypeColumn && (
            <th className="property-type-th">
              <p>Property</p>
              <p>Type</p>
            </th>
          )}
          <th className="address-th">Address</th>
          <th className="list-price-th">List Price</th>
          <th className="sale-price-th">Sale Price</th>
          <th>
            <p>Days on</p>
            <p>Market</p>
          </th>
          <th>
            <p>Beds</p>
          </th>
          <th>
            <p>Baths</p>
          </th>
          <th>
            <p>Living</p>
            <p>SqFt</p>
          </th>
        </tr>
      </thead>
    );
    let useRecentToOldDate = true;
    if (listgenUserID === "105794") {
      useRecentToOldDate = true;
    }
    //adding comment
    let isLosOlivos = mlsAreaID === "SBA-40G";
    let pendingAndContingents =
      Number(totalPendingListings) + Number(contingentsNum);
    let tableStyles;
    if (currentSolds && currentSolds.length <= 8) {
      tableStyles = "move-table-up";
    }

    let allAgentLicenses = [];
    if (isMemberOfTeam && teamMembers && teamMembers.length > 1) {
      teamMembers.map((member) =>
        allAgentLicenses.push(member.agentLicenseNumber),
      );
    }
    let needsAgentDisclaimer = sorted.some(
      (list) => list.isAgentFiltered === true,
    );

    let hasOffMarketDisclaimer = sorted.some(
      (property) => property.isOffMarketSale === "1",
    );
    let coListingDisclaimer;
    let coListing710FrenchmansDisclaimer = sorted.some(
      (property) =>
        (property.streetNumber === "710" &&
          property.streetName === "Frenchmans" &&
          listgenUserID === "102527") ||
        (property.streetNumber === "855" &&
          property.streetName === "Allardice" &&
          listgenUserID === "102527"),
    );
    let extraDisclaimer = false;
    if (mlsAreaID === "SMA-470") {
      let has2533Hayward = sorted.some(
        (list) =>
          list.streetNumber === "2533" &&
          list.streetName === "Hayward" &&
          list.streetSuffix === "Dr",
      );
      if (has2533Hayward) {
        extraDisclaimer = true;
      }
    }
    let soldDisclaimer = false;

    let specialDomDisclaimer = false;
    //adding comment
    if (mlsAreaID === "SMA-470") {
      let has1556BernalAve = sorted.some(
        (list) =>
          list.streetNumber === "1556" &&
          list.streetName === "Bernal" &&
          list.streetSuffix === "Ave",
      );
      if (has1556BernalAve) {
        specialDomDisclaimer = true;
      }
    }
    let isGailPearl = listgenUserID === "103455";
    if (extraDisclaimer) {
      tableStyles = "higher-up-market-sales-table";
    }
    let buyersAgentDisclaimer;
    if (mlsAreaID === "SMA-429") {
      let has721LindaCourt = sorted.some(
        (list) =>
          list.streetNumber === "721" &&
          list.streetName === "Linda" &&
          list.streetSuffix === "CT",
      );
      if (has721LindaCourt) {
        buyersAgentDisclaimer = true;
      }
    }
    let marketSalesTitleStyles;
    if (mlsAreaID === "SMA-390") {
      marketSalesTitleStyles = "medium-market-sales-title";
    }
    let isSameDate =
      this.formatLastPrintDate(oldestSaleDate) === this.getTodayDate();
    let showRegularDisclaimer = true;
    if (listgenUserID === "107253") {
      showRegularDisclaimer = false;
    }
    let disclaimerStyles;
    if (listgenUserID === "108206") {
      disclaimerStyles = "disclaimer-right-aligned";
    }
    if (brokerageName && brokerageName.includes("Berkshire")) {
      brokerageName = "Berkshire Hathaway HomeServices California Properties";
    }
    let bothMarketTableStyles;
    let noHeightAgentDisclaimer;

    let adjustedHeightDisclaimerStyles;
    if (mlsAreaID === "CCA-4500F") {
      adjustedHeightDisclaimerStyles = "disclaimer-height-10";
    }

    return (
      <div
        className={`${
          printVersion
            ? "print-ye2-market-sales-table"
            : "editor-ye2-market-sales-table"
        } ${
          useExtendedTable && "extended-table-container"
        } ${tableStyles} ${tableMonthStyles}`}
      >
        <div className="market-sales-title-container">
          <p className={`market-sales-subtitle-text ${marketSalesTitleStyles}`}>
            Here's What's Happening in{" "}
            {listgenUserID === "102935" ||
            listgenUserID === "100652" ||
            listgenUserID === "100661" ||
            listgenUserID === "109954"
              ? "Our Neighborhood"
              : isLosOlivos
                ? "LOS OLIVOS"
                : isBuellton
                  ? "BUELLTON"
                  : listgenUserID === "101332" && mlsAreaID === "SCL-14H"
                    ? "Our Neighborhood"
                    : mlsAreaID === "SMA-390"
                      ? "Your Sea Colony Neighborhood"
                      : "Your Neighborhood"}
          </p>

          {adjustedHeightDisclaimerStyles ? (
            <div className={`${adjustedHeightDisclaimerStyles}`}></div>
          ) : noHeightAgentDisclaimer ? (
            <div className="no-height-agent-disclaimer"></div>
          ) : mlsAreaID === "SMA-392" ||
            listgenUserID === "x110007" ? null : extraDisclaimer === "x" ? (
            ""
          ) : needsAgentDisclaimer && !isGailPearl ? (
            <div className="ye2-shortened-table-disclaimer">
              <div className="ye2-shortened-table-disclaimer-text">
                {listgenUserID === "112334" ? (
                  <div className="double-disclaimer-text">
                    <p className="initial-sample-disclaimer-text">
                      Activity Sample
                    </p>
                    <p>
                      Take a look at {isMemberOfTeam ? "our" : "my"} recent
                      activity
                      <span className="color-1"> Highlighted in Blue</span>
                    </p>
                  </div>
                ) : listgenUserID === "106421" ? (
                  <p>
                    Julie Flouty's recent activity
                    <span className="color-1"> Highlighted in Blue</span>
                  </p>
                ) : (
                  <p>
                    Take a look at {isMemberOfTeam ? "our" : "my"} recent
                    activity
                    <span className="color-1"> Highlighted in Blue</span>
                  </p>
                )}
              </div>
            </div>
          ) : listgenUserID === "112334" ? (
            <div className="ye2-shortened-table-disclaimer">
              <div className="ye2-shortened-table-disclaimer-text">
                <div className="double-disclaimer-text">
                  <p className="initial-sample-disclaimer-text">
                    Activity Sample
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="ye2-shortened-table-disclaimer"></div>
          )}

          {extraDisclaimer && (
            <div className="ye2-shortened-table-disclaimer less-margin-top-table-disclaimer">
              <div className="ye2-shortened-table-disclaimer-text">
                {specialDomDisclaimer && (
                  <p className="mt-left-disclaimer-text">
                    * The Days on Market for this property has been left out of
                    data calculations
                  </p>
                )}
                <p>** Outlier selling price not included in averages</p>
              </div>
            </div>
          )}
          {specialDomDisclaimer && (
            <div className="ye2-shortened-table-disclaimer less-margin-top-table-disclaimer">
              <div className="ye2-shortened-table-disclaimer-text">
                <p className="mt-left-disclaimer-text">
                  * The Days on Market for this property has been left out of
                  data calculations
                </p>
              </div>
            </div>
          )}
        </div>
        <div className="subtitle-row">
          <div className="left-subtitle-section">
            <div className="left-subtitle-text">
              {isSameDate ? (
                <p className="small-left-subtitle">Market Activity</p>
              ) : useRecentToOldDate ? (
                <p className="small-left-subtitle">
                  {this.formatLastPrintDate(oldestSaleDate)} —{" "}
                  {this.getTodayDate()}
                </p>
              ) : (
                <p className="small-left-subtitle">
                  {this.getTodayDate()} —{" "}
                  {this.formatLastPrintDate(oldestSaleDate)}
                </p>
              )}
            </div>
            <div className="right-subtitle-section">
              <p>
                Active Listings: {totalActiveListings ? totalActiveListings : 0}
              </p>
              <div className="right-subtitle-divider">|</div>
              <p>Pending: {pendingAndContingents}</p>
            </div>
          </div>
          <div className="golden-divider extra-long" />
        </div>
        <div className="market-table-containers">
          {/*{printVersion ? (
            <div
              className={`mini-table-gradient ${
                useExtendedTable && "extended-bg-image"
              }`}
            ></div>
          ) : (
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/020724_TableBG_DogWood-1.png"
              alt="Market Table Cloud"
              className={`market-table-bg-image ${
                useExtendedTable && "extended-bg-image"
              }`}
            />
          )}*/}
          <div className={`both-market-tables ${bothMarketTableStyles}`}>
            {useExtendedTable ? (
              <table
                className={`regular-sales-table ${
                  hidePropertyTypeColumn ? "hide-property-type" : ""
                }`}
              >
                {sorted.length >= 1 ? tableHeader : null}
                {currentSolds}
              </table>
            ) : (
              <table
                className={`regular-sales-table ${
                  hidePropertyTypeColumn ? "hide-property-type" : ""
                }`}
              >
                {sorted.length >= 1 ? tableHeader : null}
                {currentSolds}
              </table>
            )}
          </div>
          <div
            className={`ye2-market-sales-table-brokerage-disclaimer ${disclaimerStyles}`}
          >
            {showRegularDisclaimer && (
              <p>
                {tableBrokerageFilter(brokerageName)} did not necessarily
                participate in the above transactions.
              </p>
            )}
          </div>
          {(coListingDisclaimer || coListing710FrenchmansDisclaimer) && (
            <div className="ye2-market-sales-table-colisting-disclaimer">
              {coListingDisclaimer && <p>CL: Co-Listing </p>}
              {coListing710FrenchmansDisclaimer && (
                <p>*CL: Co-Listed with Shari Ornstein</p>
              )}
            </div>
          )}

          {buyersAgentDisclaimer && (
            <div className="ye2-market-sales-table-colisting-disclaimer">
              <p>* I am the buyer's agent</p>
            </div>
          )}
          {hasOffMarketDisclaimer && (
            <div className="off-market-disclaimer">
              <div className="off-market-disclaimer-text">
                *Sold privately off market and was not publicly listed on the
                Multiple Listing Service. (MLS)
              </div>
            </div>
          )}
          {soldDisclaimer && (
            <div className="off-market-disclaimer">
              <div className="off-market-disclaimer-text">
                * This property was our sale
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default YETwoShortenedMarketTable;
